import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ApplicantDigitalCVModel,
  CVAddModel,
  CVUploadResultModel,
  DigitalCVModel,
  DigitalVacancyModel,
} from '@digilize/shared/definitions/src';

@Injectable({
  providedIn: 'root',
})
export class CvService {
  private readonly http = inject(HttpClient);

  getCV = () => this.http.get<DigitalCVModel>('/api/v1.0/cv');

  getCVbyId = (id: string) => this.http.get<ApplicantDigitalCVModel>(`/api/v1.0/cv/${id}`);

  manualCV = (cv: CVAddModel) => this.http.post('/api/v1.0/manual-cv', cv);

  uploadCV = (cv: FormData, source?: string) => {
    let params = new HttpParams();
    if (source) {
      params = params.set('source', source);
    }
    return this.http.post<CVUploadResultModel>('/api/v1.0/cv', cv, { params });
  };

  uploadVacancy = (vacancy: unknown) => this.http.post<DigitalVacancyModel>('/api/v1.0/vacancy', vacancy);

  updateCV = (cv: DigitalCVModel) => this.http.put<DigitalCVModel>('/api/v1.0/cv', cv);
}
